const integerFormatter = new Intl.NumberFormat('ru-RU', {
  maximumFractionDigits: 0,
})

const naturalTextCollator = new Intl.Collator('ru', {
  numeric: true,
  sensitivity: 'base',
})

export function formatInteger(value: number | string | null | undefined): string {
  const number = Number(value)
  return Number.isFinite(number) ? integerFormatter.format(number) : '—'
}

export function compareNaturalText(
  left: string | number | null | undefined,
  right: string | number | null | undefined,
): number {
  return naturalTextCollator.compare(String(left ?? ''), String(right ?? ''))
}
